
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, pageId }) => {
  const adminInfo = JSON.parse(sessionStorage.getItem("adminInfo"));
  const permissions = adminInfo?.permission || [];

 
  const allowedPageIds = permissions.map(p => p.pageid);
  const hasAccess = allowedPageIds.includes(pageId);

  return hasAccess ? children : <Navigate to="/not-authorized" replace />;
};

export default ProtectedRoute;
